import ProviderListPage from "./pages/ProviderListPage";
import ProviderCreatePage from "./pages/ProviderCreatePage";
import ProviderDetailPage from "./pages/ProviderDetailPage";

export const providerRoutes = (prefix = "providers") => [
  {
    name: "ProviderCreatePage",
    path: `${prefix}/create`,
    component: ProviderCreatePage
  },
  {
    name: "ProviderDetailPage",
    path: `${prefix}/:id`,
    component: ProviderDetailPage
  },
  { name: "ProviderListPage", path: prefix, component: ProviderListPage }
];
